<template>
    <div class="modal-overlay">
      <div class="modal">
        <h2>Create API Key</h2>
        <form @submit.prevent="createApiKey">
          <div class="input-group">
            <label for="chatbot">Chatbot ID</label>
            <input type="text" id="chatbot" v-model="apiKeyData.chatbot" disabled>
          </div>
          <button type="submit" class="btn">Create</button>
          <button type="button" class="btn" @click="$emit('close')">Cancel</button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import apiService from '@/apiService';
  
  export default {
    name: 'CreateApiKeyModal',
    props: {
      chatbotId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        apiKeyData: {
          chatbot: this.chatbotId
        }
      };
    },
    methods: {
      async createApiKey() {
        try {
          const response = await apiService.post('/api/apikeys/', this.apiKeyData);
          this.$emit('api-key-created', response.data);
          this.$emit('close');
        } catch (error) {
          console.error('Error creating API key:', error);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal {
    background-color: #1e1e2f;
    padding: 20px;
    border-radius: 10px;
    width: 400px;
  }
  
  h2 {
    color: #ffffff;
    margin-bottom: 20px;
  }
  
  .input-group {
    margin-bottom: 20px;
    text-align: left;
  }
  
  label {
    color: #ffffff;
    display: block;
    margin-bottom: 5px;
  }
  
  input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #444;
    background-color: #2a2a3d;
    color: #ffffff;
  }
  
  button {
    width: 100%;
    padding: 10px;
    margin-top: 10px;
    border-radius: 5px;
    border: none;
    background-color: #3b3b4e;
    color: #ffffff;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #4b4b5e;
  }
  </style>
  